import { useEffect, useState } from "react";
import { useQuery, useMutation } from "react-query";
import NavigasiAdmin from "../../components/NavigasiAdmin";
import { API } from "../../config/api";
import image from "../../assets/img/empty.svg";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import DeleteData from "../../components/DeleteData";

function ListCategory() {
  document.title = "List Category";
  let navigate = useNavigate();

  const [query, setQuery] = useState("");

  // Variabel for delete category data
  const [idDelete, setIdDelete] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);

  // Modal Confirm delete data
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // For get id category & show modal confirm delete data
  const handleDelete = (id) => {
    setIdDelete(id);
    handleShow();
  };

  // If confirm is true, execute delete data
  const deleteById = useMutation(async (id) => {
    try {
      await API.delete(`/category/${id}`);
      refetch();
    } catch (error) {
      console.log(error);
    }
  });

  let { data: categories, refetch } = useQuery("categoriesCache", async () => {
    const response = await API.get("/categories");
    return response.data.data;
  });

  const handleEdit = (id) => {
    navigate(`/edit-category/${id}`);
  };

  useEffect(() => {
    if (confirmDelete) {
      // Close modal confirm delete data
      handleClose();
      // execute delete data by id function
      deleteById.mutate(idDelete);
      setConfirmDelete(null);
    }
  }, [confirmDelete]);

  return (
    <>
      <NavigasiAdmin active="category" />
      <div className="list-category-section container">
        <p className="fw-bold mt-5 mb-4">List Category</p>
        <div className="row d-flex justify-content-between">
          <div className="col-md-2">
            <Link to="/add-category" className="btn btn-dark w-100">
              Add
            </Link>
          </div>
          <div className="col-md-3">
            <input
              type="text"
              name="search"
              id="search"
              className="bg-dark text-white mb-3 form-control"
              placeholder="Search category name"
              onChange={(event) => setQuery(event.target.value)}
            />
          </div>
        </div>
        {categories?.length !== 0 ? (
          <>
            <table
              className="table table-dark table-striped"
              style={{ fontFamily: "Arial" }}
            >
              <thead>
                <tr>
                  <th scope="col">No</th>
                  <th scope="col" width="50%">
                    Category Name
                  </th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {categories
                  ?.filter((data) => {
                    if (query === "") {
                      return data;
                    } else if (
                      data.name.toLowerCase().includes(query.toLowerCase())
                    ) {
                      return data;
                    }
                  })
                  ?.map((category, index) => (
                    <tr key={category.id}>
                      <th>{index + 1}</th>
                      <td>{category.name}</td>
                      <td>
                        <div className="row">
                          <div className="col-md-4">
                            <Button
                              onClick={() => {
                                handleEdit(category.id);
                              }}
                              className="btn-sm btn-success w-100"
                            >
                              Edit
                            </Button>
                          </div>
                          <div className="col-md-4">
                            <Button
                              onClick={() => {
                                handleDelete(category.id);
                              }}
                              className="btn-sm btn-danger w-100"
                            >
                              Delete
                            </Button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </>
        ) : (
          <>
            <div className="text-center pt-5">
              <img
                src={image}
                className="img-fluid my-5"
                style={{ width: "40%" }}
                alt="noData"
              />
              <div className="mt-3 mb-5">No data category</div>
            </div>
          </>
        )}
      </div>

      <DeleteData
        setConfirmDelete={setConfirmDelete}
        show={show}
        handleClose={handleClose}
      />
    </>
  );
}

export default ListCategory;
